import { legacyStorageGet, legacyStorageSet } from "@/utils/legacyStorage";
import { NotificationsResponse } from "@/types/domain";

// Matches legacy notify.js localStorage keys

const CACHE_KEY_PREFIX = "NotificationCache_";
const DISMISSED_KEY_PREFIX = "DISMISSED_NOTIFICATIONS_";

// NotificationItem/TaskReminderItem use PascalCase to match the legacy cache
// format, so they can be stored/restored directly without any conversion.
export const readCache = (databaseId: string): NotificationsResponse | null => {
  try { return legacyStorageGet<NotificationsResponse>(`${CACHE_KEY_PREFIX}${databaseId}`); }
  catch { return null; }
};

export const writeCache = (databaseId: string, data: NotificationsResponse) => {
  try { legacyStorageSet(`${CACHE_KEY_PREFIX}${databaseId}`, data); }
  catch { /* non-critical */ }
};

const dismissedKey = (databaseId: string) => `${DISMISSED_KEY_PREFIX}${databaseId}`;

export const isDismissed = (databaseId: string, notificationId: string): boolean => {
  try {
    const ids = legacyStorageGet<string[]>(dismissedKey(databaseId)) ?? [];
    return ids.includes(notificationId);
  } catch { return false; }
};

export const markDismissed = (databaseId: string, notificationId: string) => {
  try {
    const ids = legacyStorageGet<string[]>(dismissedKey(databaseId)) ?? [];
    if (!ids.includes(notificationId)) {
      legacyStorageSet(dismissedKey(databaseId), [...ids, notificationId]);
    }
  } catch { /* non-critical */ }
};

export const cleanupDismissed = (databaseId: string, currentIds: string[]) => {
  // Remove dismissed IDs that no longer exist on the server (legacy behaviour)
  try {
    const ids = legacyStorageGet<string[]>(dismissedKey(databaseId));
    if (!ids) return;
    legacyStorageSet(dismissedKey(databaseId), ids.filter((id) => currentIds.includes(id)));
  } catch { /* non-critical */ }
};
